<template>
  <v-badge
    overlap
    :content="computedValue?.length"
    :value="computedValue?.length || false"
    color="error"
    :offset-x="15"
  >
    <v-select
      ref="sel"
      class="select-chip"
      v-on="$listeners"
      v-bind="{ ...staticProps, ...$props, ...this.$_filterObjectKeys($attrs, { notAllowedKeys: ['label'] }) }"
      :style="[currentColor]"
      :dark="!$_isHexColorLight(computedColor) ? true : false"
      :color="!$_isHexColorLight(computedColor) ? '#fff' : '#202124'"
      multiple
      v-model="computedValue"
    >
      <template #selection></template>
      <template #prepend-inner>
        <span class="select-chip-label"> {{ $attrs.label }} </span>
      </template>
    </v-select>
  </v-badge>
</template>
<script>
export default {
  name: 'DataInputSelectchip',
  props: {
    value: {
      type: [Array],
    },
    color: {
      type: String,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    computedColor() {
      return this.color || this.$_colors.third;
    },
    currentColor() {
      return {
        '--current-color': this.computedColor,
        '--main-color': this.$_isHexColorLight(this.computedColor) ? '#202124' : 'white',
        'font-weight': 500,
      };
    },
  },
  data: () => ({
    staticProps: {
      hideDetails: true,
      solo: true,
      singleLine: true,
      menuProps: {
        offsetY: true,
      },
      class: 'text-body-2',
      height: '30px',
    },
  }),
};
</script>
<style lang="scss" scoped>
.select-chip {
  ::v-deep .v-input__control .v-input__slot .v-select__slot .v-label {
    position: static !important;
    right: 0 !important;
    width: 100%;
  }
  ::v-deep .v-input__control .v-input__slot .v-select__slot .v-select__selections input {
    display: none !important;
  }
  ::v-deep .v-input__control .v-input__slot .v-input__prepend-inner {
    padding: 0 !important;
  }
  ::v-deep .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-select__selection,
  ::v-deep .v-input__control .v-input__slot .v-select__slot .v-label,
  ::v-deep .v-input__control .v-input__slot .v-input__prepend-inner span {
    margin-right: 0;
    max-width: 100%;
  }
  ::v-deep {
    .v-input__append-inner {
      padding: 0;
    }
    .v-input__slot {
      padding: 0 4px 0 8px !important;
    }
    .select-chip-label {
      font-size: 11px !important;
      font-weight: 500 !important;
      color: white !important;
    }
  }
}

::v-deep {
  .v-input__slot {
    min-height: 30px !important;
    background-color: var(--current-color) !important;
    fieldset {
      border: none !important;
    }
  }
  .v-input__control {
    min-height: unset !important;
  }
  .v-select__selection--comma {
    color: unset !important;
  }
  .v-select__selection {
    color: var(--main-color) !important;
  }
  .v-select__slot label {
    font-size: 14px !important;
  }
  .v-input__icon i {
    color: var(--main-color) !important;
    font-size: 20px;
  }
  .v-icon--disabled {
    display: none;
  }
  .v-input__icon--clear {
    margin-left: 10px;
  }
  .v-input--selection-controls__input .v-icon {
    color: var(--current-color) !important;
  }
}
.v-badge--overlap {
  width: 100% !important;
  ::v-deep {
    .v-badge__badge {
      z-index: 2;
    }
  }
}
</style>
